import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import FloatingCTA from "./components/FloatingCTA";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import GalleryPage from "./pages/GalleryPage";
import Profil from "./pages/Profil";
import Kontakt from "./pages/Kontakt";
import Error404 from "./pages/Error404";
import Error403 from "./pages/Error403";
import { REDIRECTS_MAP } from "./data";

// Redirect component to handle 301 redirects
function RedirectHandler({ children }) {
  const location = useLocation();
  const pathname = location.pathname;

  // Check if current path needs a redirect, and ensure we don't redirect to the same path
  const targetPath = REDIRECTS_MAP[pathname];
  if (targetPath && targetPath !== pathname) {
    return <Navigate to={targetPath} replace />;
  }

  // Handle trailing slash normalization if needed, but only if it results in a different path
  if (pathname.endsWith("/") && pathname !== "/") {
    const withoutSlash = pathname.slice(0, -1);
    if (REDIRECTS_MAP[withoutSlash]) {
      return <Navigate to={REDIRECTS_MAP[withoutSlash]} replace />;
    }
  }

  return children;
}

function App() {
  const location = useLocation();

  // Ensure scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <HelmetProvider>
      <div className="flex min-h-screen flex-col bg-brand-beige text-brand-graphite antialiased selection:bg-brand-brown/20 selection:text-brand-brown-dark">
        {/* Scroll to top component */}
        <ScrollToTop />

        {/* Floating CTA buttons */}
        <FloatingCTA />

        {/* Header Navigation */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <RedirectHandler>
            <Routes>
              {/* Home Route */}
              <Route path="/" element={<Home />} />
              <Route path="/index" element={<Navigate to="/" replace />} />

              {/* Static Pages */}
              <Route path="/profil" element={<Profil />} />
              <Route path="/kontakt" element={<Kontakt />} />
              
              {/* Gallery & References */}
              <Route path="/galleri" element={<GalleryPage />} />
              <Route path="/referencer-2" element={<GalleryPage />} />

              {/* Dynamic Service Detail Routes */}
              <Route path="/:slug" element={<ServiceDetail />} />

              {/* Error Routes */}
              <Route path="/403" element={<Error403 />} />
              <Route path="/404" element={<Error404 />} />
              <Route path="*" element={<Error404 />} />
            </Routes>
          </RedirectHandler>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
